import {AspRoles, AspSalesAdminRoles, AspServiceAdminRoles, AspServiceAdminRolesT2, AspPartsAdminRoles, DD365Roles, DD365DistRoles, isSpServiceDashboardOverride, unsubscribeSubscriptions} from './../shared/services/util.service';
import {AuthService} from './../shared/services/auth.service';
import {NavigationModel} from './../shared/models/navigation.model';
import {Component, OnDestroy, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {environment, globalTXM, isSpServiceSchedulingOverride} from '../shared/services/util.service';
import { Department } from '@signal/asp-data-commons';
import { Store } from '@ngrx/store';
import { LoadNotificationDashboardData } from '../store/service-appointment/service-appointment.actions';
import { ServiceAppointmentState } from '../store/service-appointment/service-appointment.reducer';
import { selectNotificationDashboardData } from '../store/service-appointment/service-appointment.selectors';
import { SubscriptionList } from '../shared/models/asp.types';
import { DealerState } from '../store/dealer/dealer.reducer';
import * as fromDealerSelectors from './../store/dealer/dealer.selectors';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {
  partsRootRoute: string = '/asp/parts';
  serviceNav : string = '/service';
  testdriveNav : string = '/testdrive';
  deliveryNav : string = '/delivery';
  vehiclenquiryNav  = '/vehicleinquiry';
  scheduleDashboard : string = '/scheduledashboard';
  settings : string = '/settings';
  servicePersonnel : string = '/manageadvisors';
  serviceScheduleTrans : string = 'navigation.serviceSchedule';
  servicePersonnelTrans: string = 'navigation.servicePersonnel';
  advisorMsg : string = 'navigation.pleaseMakeServiceAdvisorsOnline';
  salesadvisorMsg: string = 'navigation.pleaseMakeSalesAdvisorsOnline';
  scheduleRotation : string = 'navigation.scheduleRotation';
  scheduleRotationNav : string = '/schedulerotation';
  holidaysNav : string = '/manageholidays';
  capacityNav : string = '/managecapacity';
  transportCapacityNav : string = '/managetransportcapacity';
  transportCapacity : string = 'navigation.transportCapacity';
  searchAnotherCustomer : string = 'navigation.customer';
  customerDashboard : string = 'navigation.customerDashboard';
  dashboardNav : string = '/dashboard';
  scheduleAppointment : string = 'navigation.scheduleAppointment';
  service : string = 'navigation.service';
  testDrive : string = 'navigation.testDrive';
  delivery : string = 'navigation.delivery';
  partsPickUp: string = 'navigation.partsPickUp';
  enquiry  = 'navigation.vehicleInquiry';
  generalSettings : string = 'navigation.generalSettings';
  search : string = 'navigation.search';
  dashboard : string = 'navigation.dashboard';
  navParts = 'navigation.parts';
  navSales = 'navigation.sales';
  navScheduling = 'navigation.scheduling';
  unavailableVehicles= 'navigation.unavailableVehicles';
  deliveryChecklist='deliveryChecklist.deliveryChecklist';
  parts = 'navigation.parts';
  isSales=true;
  isService=true;
  isPartsAccessible = true;
  isSalesFeatureFlag = true;
  isServiceFeatureFlag = true;
  isDeliveryChecklistAccessible=true;
  private subs: SubscriptionList = {};

  private getNavItemByName(navName: string): NavigationModel | undefined {
    return this.navItems.find(navItem => navItem.name === navName);
  }

  private setSchedulingAppointmentSubNav() {
    const schedulingNav = this.getNavItemByName(this.navScheduling);
    const scheduleAppointmentNav = schedulingNav?.subNav?.find(subNav => subNav.name === this.scheduleAppointment);
    if (scheduleAppointmentNav) {
      const baseSubNav = environment.showDelivery ? this.bdcSubNavListWithDeliveryRoute : this.bdcSubNavListWithOutDeliveryRoute;
      // Filter out parts-pickup if not accessible
      scheduleAppointmentNav.subNav = this.isPartsAccessible ? baseSubNav : baseSubNav.filter(nav => nav.name !== this.partsPickUp);
    }
  }

  private setServiceSubNavByTxmFlag() {
    const serviceNav = this.getNavItemByName(this.service);
    if (serviceNav) {
      serviceNav.subNav = globalTXM ? this.serviceSubNavListWithTxmManagementRoute : this.serviceSubNavListWithoutTxmManagementRoute;
    }
  }

  private removeSchedulingSubNavByName(name: string) {
    const schedulingNav = this.getNavItemByName(this.navScheduling);
    if (schedulingNav?.subNav) {
      schedulingNav.subNav = schedulingNav.subNav.filter(subNav => subNav.name !== name);
    }
  }

  bdcSubNavListWithDeliveryRoute = 
  [
    {name: this.service, route: this.serviceNav},
    {name: this.enquiry, route:this.vehiclenquiryNav},
    {name: this.testDrive, route: this.testdriveNav},
    {name: this.delivery, route: this.deliveryNav},
      { name: 'navigation.learning', route: '/tech-appointment' },
      ...(environment.enableParts ? [{ name: this.partsPickUp, route: '/parts' }] : [])
  ]

  bcdSubNvaCustomerRoute =
  [
    {name: this.search, route: "/customer"},
    {name: this.dashboard, route: "/dashboard"},
    {name: 'navigation.pendingAppointments', route: '/pending'},
    {name: this.unavailableVehicles, route: '/appointment-conflicts'}
  ]

  bdcSubNavListWithOutDeliveryRoute = 
  [
    {name: this.service, route: this.serviceNav},
    {name: this.testDrive, route: this.testdriveNav},
      { name: 'navigation.learning', route: '/tech-appointment' },
      ...(environment.enableParts ? [{ name: this.partsPickUp, route: '/parts' }] : [])
  ]
  serviceSubNavListWithTxmManagementRoute = [
        {name: this.serviceScheduleTrans, route: this.scheduleDashboard, key:'', isButtonRequired : false, hoverMsg : ''},
        {name: this.generalSettings, route: this.settings, key: '', isButtonRequired : false, hoverMsg : ''},
        {name: 'navigation.opcodeServiceManagement', route: '/opcodeservicemanagement',key: 'onlineopcodes', isButtonRequired : false, hoverMsg : 'navigation.pleaseMakeServiceOfferingsOnline'},
        {name: this.servicePersonnelTrans, route: this.servicePersonnel, key: 'activeemployees',  isButtonRequired : false, hoverMsg : this.advisorMsg},
        {name: 'navigation.teamManagement', route: '/teammanagement', key: '', isButtonRequired : false, hoverMsg : ''},
        {name: 'navigation.txmManagement', route: '/txm', key: '', isButtonRequired : false, hoverMsg : ''},
        {name: this.scheduleRotation, route: this.scheduleRotationNav, key: '', isButtonRequired : false, hoverMsg : ''},
        {name: 'navigation.serviceHolidays', route: this.holidaysNav, key: '', isButtonRequired : false, hoverMsg : ''},
        {name: 'navigation.serviceCapacity', route: this.capacityNav, key: '', isButtonRequired : false, hoverMsg : ''},
        {name: this.transportCapacity, route: this.transportCapacityNav, key: '', isButtonRequired : false, hoverMsg : ''}
        // { name: 'Capacity Override', route: '/capacityoverride' },
  ]
  serviceSubNavListWithoutTxmManagementRoute=[
        {name: this.serviceScheduleTrans, route: this.scheduleDashboard, key:'', isButtonRequired : false, hoverMsg : ''},
        {name: this.generalSettings, route: this.settings, key:'', isButtonRequired : false, hoverMsg : ''},
        {name: 'navigation.opcodeServiceManagement', route: '/opcodeservicemanagement', key:'onlineopcodes',  isButtonRequired : false, hoverMsg : 'navigation.pleaseMakeServiceOfferingsOnline'},
        {name: this.servicePersonnelTrans, route: this.servicePersonnel, key:'activeemployees',  isButtonRequired : false, hoverMsg : this.advisorMsg},
        {name: 'navigation.teamManagement', route: '/teammanagement', key:'', isButtonRequired : false, hoverMsg : ''},
        {name: this.scheduleRotation, route: this.scheduleRotationNav, key:'', isButtonRequired : false, hoverMsg : ''},
        {name: 'navigation.serviceHolidays', route: this.holidaysNav, key:'', isButtonRequired : false, hoverMsg : ''},
        {name: 'navigation.serviceCapacity', route: this.capacityNav, key:'', isButtonRequired : false, hoverMsg : ''},
        {name: this.transportCapacity, route: this.transportCapacityNav, key:'', isButtonRequired : false, hoverMsg : ''},
        // { name: 'Capacity Override', route: '/capacityoverride' },
  ]

  digitalChecklistRoute = [
    {name: 'navigation.pending', route: '/pending'},
    {name: 'navigation.completed', route: '/completed'},
  ];


  navItems: NavigationModel[] = [
    // {
    //   name: 'Dashboard',
    //   route: '/asp/dashboard',
    //   subNav: []
    // },
    {
      name: this.navParts,
      route: this.partsRootRoute,
      subNav: [
        {name: 'navigation.partsSchedule', route: this.scheduleDashboard},
        {name: this.generalSettings, route: this.settings},
        {name: 'navigation.partsAdvisor', route: this.servicePersonnel, isButtonRequired: false, hoverMsg : this.advisorMsg, key : "activeemployees"},
        {name: 'navigation.partsHolidays', route: this.holidaysNav}
      ]
    },
    {
      name: this.navSales,
      route: '/asp/sales',
      subNav: [
        {name: 'navigation.salesSchedule', route: this.scheduleDashboard},
        {name: this.generalSettings, route: this.settings},
        {name: 'navigation.salesAdvisor', route: this.servicePersonnel, isButtonRequired: false, hoverMsg : this.salesadvisorMsg, key : "activeemployees"},
        {name: this.scheduleRotation, route: this.scheduleRotationNav},
        {name: 'navigation.salesHolidays', route: this.holidaysNav},
        {name: 'navigation.salesCapacity', route: this.capacityNav},
        {name: 'navigation.remoteCapacity', route: this.transportCapacityNav},
        {name: 'vehicleManagement.testDriveFleet', route: '/vehicle', key: 'testdriveDeletePending', isButtonRequired: false, hoverMsg: 'testDrive.pleaseCheckTheUpcomingTestDriveAppointmentsWithUnavailableVehicles'},
        // {name: 'checklist.deliveryLearningChecklistSetup', route: '/checklist', key: 'checkList', isButtonRequired: false, 
        // hoverMsg: 'checklist.pleaseAddDurationToAllChecklistItems'}
      ]
    },
    {
      name: this.service,
      route: '/asp/service',
      subNav: []
    },
    {
      name: this.navScheduling,
      route: '/asp/bdc',
      subNav: [
        {
          name: this.searchAnotherCustomer, route: '',
          subNav: this.bcdSubNvaCustomerRoute},
        {
          name: this.scheduleAppointment, route: '',
          subNav: []
        },
        {name: 'navigation.serviceScheduleDashboard', route: this.scheduleDashboard},
        { name: 'navigation.salesScheduleDashboard', route: "/salesscheduledashboard" },
        { name: 'navigation.partsScheduleDashboard', route: "/partsscheduledashboard" }
      ]
    },
    {
      name: this.deliveryChecklist,
      route: '/asp/deliveryChecklist',
      subNav: [
        {
          name: 'deliveryChecklist.checklistSummary', route: '/summary',
          subNav: this.digitalChecklistRoute
        },
      ]
    }
  ];

  constructor(private authServive: AuthService,
    private readonly serviceAppointmentStore: Store<ServiceAppointmentState>,
    private readonly dealerState: Store<DealerState>) {
       this.subs.dealer=this.dealerState.select(fromDealerSelectors.dealerDetails).pipe(
        filter(dealerDetails => dealerDetails.data !== null && dealerDetails.data !== undefined),
        take(1)
      ).subscribe(dealerData=>{
        this.isPartsAccessible = !!environment.enableParts && !!dealerData.data?.isPartsAccessible;
        this.isSalesFeatureFlag = dealerData.data?.isSalesAccessibleFeatureFlag;
        this.isServiceFeatureFlag = dealerData.data?.isServiceAccessibleFeatureFlag;
        this.isDeliveryChecklistAccessible=dealerData.data?.isDeliveryChecklistAccessible;
      });
    this.serviceAppointmentStore.dispatch(new LoadNotificationDashboardData({department: Department.SERVICE}));
    this.setServiceSubNavByTxmFlag();
    if(this.isSalesFeatureFlag === undefined && this.isServiceFeatureFlag === undefined){
    if(!this.isSales)
    {
      this.navItems = this.navItems.filter(navItem => navItem.name !== this.navSales);
      this.bcdSubNvaCustomerRoute.splice(2)
      this.bdcSubNavListWithDeliveryRoute.splice(1); 
      this.removeSchedulingSubNavByName('navigation.salesScheduleDashboard');
    }
    if(!this.isService && !isSpServiceSchedulingOverride)
    {
      this.navItems = this.navItems.filter(navItem => navItem.name !== this.service);
      this.bdcSubNavListWithDeliveryRoute.splice(0,1);
      if(!isSpServiceDashboardOverride) {
        this.removeSchedulingSubNavByName('navigation.serviceScheduleDashboard');
      }
    }
    if(!this.isSales && (!this.isService && !isSpServiceSchedulingOverride)) {
      this.removeSchedulingSubNavByName(this.scheduleAppointment);
    }
  }else{
    this.checkFeatureFlags()
  }
  
  this.setSchedulingAppointmentSubNav();

    if(!this.isDeliveryChecklistAccessible)
    {
      this.navItems = this.navItems.filter(navItem=> navItem.name !== this.deliveryChecklist);
    }
    this.subs.getRoles = this.authServive.getEmployeeRoles().subscribe(t => { 
      this.navItems = this.navItems.filter(navItem => this.hasAccess(t, navItem));
    });
    this.subs.notificationData = this.serviceAppointmentStore.select(selectNotificationDashboardData).subscribe((results: any) => {
        if (results && results.length > 0) {
          const partsNav = this.navItems.find(navItem => navItem.name === this.navParts);
          const salesNav = this.navItems.find(navItem => navItem.name === this.navSales);
          const serviceNav = this.navItems.find(navItem => navItem.name === this.service);
// Need to implement after parts schedule
        //   partsNav?.subNav.forEach(eachchildren => {
        //     for (const result of results) {
        //         switch (eachchildren.key === result.key) {
        //             case true: {
        //                 this.setButtonRequired(eachchildren, result);
        //                 break;
        //             }
        //             default:
        //                 break;
        //         }
        //     }
        // });
          salesNav?.subNav.forEach(eachchildren => {
            for (const result of results) {
                switch (eachchildren.key === result.key) {
                    case true: {

                        this.setButtonRequired(eachchildren, result);
                        break;
                    }
                    default:
                        break;
                }
            }
        })
        serviceNav?.subNav.forEach(eachchildren => {
              for (const result of results) {
                  switch (eachchildren.key === result.key) {
                      case true: {
                          this.setButtonRequired(eachchildren, result);
                          break;
                      }
                      default:
                          break;
                  }
              }
          }
      );
      /* *for sales schedule flow */
      salesNav?.subNav.forEach(eachchildren => {
        for (const result of results) {
            switch (eachchildren.key === result.key) {
                case true: {
                    this.setButtonRequired(eachchildren, result);
                    break;
                }
                default:
                    break;
            }
        }
    }
);
    /* set count of unavailable vehicles to show on dashboard for appointment conflict link */
    const index=this.bcdSubNvaCustomerRoute.findIndex(nav=>nav.name===this.unavailableVehicles);
    if(index!==-1)
    {
      this.bcdSubNvaCustomerRoute[index]['count']=results.filter(key=>key.key==='testdriveDeletePending')[0]?.value;
    }

    /* set count of unavailable vehicles to show on dashboard for appointment conflict link */
    const pendingIndex = this.bcdSubNvaCustomerRoute.findIndex(nav => nav.name === 'navigation.pendingAppointments');
    if(pendingIndex !== -1)
    {
      this.bcdSubNvaCustomerRoute[pendingIndex]['count'] = results.filter(key=>key.key==='pendingDelivery')[0]?.value;
    }

      /* set count of pending Digital Checklist to show in delivery checklist route */
      const pendingChecklistIndex = this.digitalChecklistRoute.findIndex(nav => nav.name === 'navigation.pending');
      if(pendingChecklistIndex !== -1)
      {
        this.digitalChecklistRoute[pendingChecklistIndex]['count'] = results.filter(key=>key.key==='pendingDigitalChecklist')[0]?.value;
      }

      /* set count of completed Digital Checklist to show in delivery checklist route */
      const completedChecklistIndex = this.digitalChecklistRoute.findIndex(nav => nav.name === 'navigation.completed');
      if(completedChecklistIndex !== -1)
      {
        this.digitalChecklistRoute[completedChecklistIndex]['count'] = results.filter(key=>key.key==='completedDigitalChecklist')[0]?.value;
      }

    }
  });
  
}

  ngOnInit() {
  }
  checkFeatureFlags(){
    if(!this.isPartsAccessible)
    {
      this.navItems = this.navItems.filter(navItem => navItem.name !== this.navParts);
      this.removeSchedulingSubNavByName('navigation.partsScheduleDashboard');
    }
    if(!this.isSalesFeatureFlag)
    {
      this.navItems = this.navItems.filter(navItem => navItem.name !== this.navSales);
      this.bcdSubNvaCustomerRoute.splice(2)
      this.bdcSubNavListWithDeliveryRoute.splice(1); 
      this.removeSchedulingSubNavByName('navigation.salesScheduleDashboard');
    }
    if(!this.isServiceFeatureFlag)
    {
      this.navItems = this.navItems.filter(navItem => navItem.name !== this.service);
      this.bdcSubNavListWithDeliveryRoute.splice(0,1);
      if(!isSpServiceDashboardOverride) {
        this.removeSchedulingSubNavByName('navigation.serviceScheduleDashboard');
      }
    }
    if(!this.isSalesFeatureFlag && !this.isServiceFeatureFlag) {
      if(isSpServiceDashboardOverride) {
        this.removeSchedulingSubNavByName('navigation.serviceScheduleDashboard');
        this.removeSchedulingSubNavByName(this.scheduleAppointment);
      }else{
        this.navItems = this.navItems.filter(navItem => navItem.name !== this.navScheduling);
      }
    }
  }
  setButtonRequired(eachchildren, result) {
    const diffConditionKeys = ['checkList', 'testdriveDeletePending'];
    eachchildren.isButtonRequired = false;
    if ((!diffConditionKeys.includes(result.key) && (result.value === 0 || result.value === "OFF" || result.value === "Inactive")) ||
      (diffConditionKeys.includes(result.key) && result.value > 0)) {
      eachchildren.isButtonRequired = true;
    }
  }

  hasAccess(roles: string[], navItem: NavigationModel) {
    let access: boolean = false;
    if (!navItem || !navItem.name) {
      return false;
    }
    switch (navItem.name) {
      case this.navScheduling:
        if(_.every(AspRoles, (t) => roles.indexOf(t) >= 0)){
          access = _.every(AspRoles, (t) => roles.indexOf(t) >= 0);
        }
        break;
      case this.navParts:
        access = _.every([...AspRoles, ...AspPartsAdminRoles], (t) => roles.indexOf(t) >= 0);
        break;
      case this.navSales:
        access = _.every([...AspRoles, ...AspSalesAdminRoles], (t) => roles.indexOf(t) >= 0);
        break;
      case this.service:
        if(_.every([...AspRoles, ...AspServiceAdminRoles, ...AspServiceAdminRolesT2], (t) => roles.indexOf(t) >= 0)){
          access = _.every([...AspRoles, ...AspServiceAdminRoles, ...AspServiceAdminRolesT2], (t) => roles.indexOf(t) >= 0);
        }else if(_.every([...AspRoles, ...AspServiceAdminRoles], (t) => roles.indexOf(t) >= 0)){
          access = _.every([...AspRoles, ...AspServiceAdminRoles], (t) => roles.indexOf(t) >= 0);
          navItem.subNav = [
            { name: this.serviceScheduleTrans, route: this.scheduleDashboard, key: '', isButtonRequired: false, hoverMsg: '' },
            { name: this.generalSettings, route: this.settings, key: '', isButtonRequired: false, hoverMsg: ''  },
            { name: this.servicePersonnelTrans, route: this.servicePersonnel, key: 'activeemployees', isButtonRequired: false, hoverMsg: this.advisorMsg  },
            { name: this.transportCapacity, route: this.transportCapacityNav, key: '', isButtonRequired: false, hoverMsg: ''  },
          ]
        }
        else{

        }
        //access = _.every([...AspRoles, ...AspServiceAdminRoles, ...AspServiceAdminRolesT2], (t) => roles.indexOf(t) >= 0);
        break;
        case this.deliveryChecklist:
        if([...DD365Roles, ...DD365DistRoles].some(role => roles.includes(role))){
            access = [...DD365Roles, ...DD365DistRoles].some(role => roles.includes(role));
        }
        break;
      default:
        break;
    }
    return access;
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }

}
